import { useStoreon } from 'storeon/react';
import { IEvents, IState } from 'src/store';
import {MetalProfilesType} from 'src/store/RoofStoreModule';

export const usePresenter = () => {
  const { dispatch, roofStore } = useStoreon<IState, IEvents>(
    'roofStore',
  );

  const setMetalProfile = (metalProfile: MetalProfilesType) => {
    dispatch('roof/set-profile-type', { profileType: metalProfile });
  };

  const setMetalTileID = (name: string) => {
    dispatch('roof/set-metalTile-name', { metalTileName: name });
  };

  const setPailingID = (name: string) => {
    dispatch('roof/set-pailing-name', { pailingName: name });
  };

  return {
    metalProfile: roofStore.profileType as MetalProfilesType,
    selectedMetalTile: roofStore.metalTileName,
    selectedPailing: roofStore.pailingName,
    setMetalProfile,
    setMetalTileID,
    setPailingID,
  };
};
